import { render, staticRenderFns } from "./NotificacaoLog.vue?vue&type=template&id=094e9fdd&"
import script from "./NotificacaoLog.vue?vue&type=script&lang=js&"
export * from "./NotificacaoLog.vue?vue&type=script&lang=js&"
import style0 from "./NotificacaoLog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports